var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclePlaySolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M52 26C52 40.3609 40.3609 52 26 52C11.6391 52 0 40.3609 0 26C0 11.6391 11.6391 0 26 0C40.3609 0 52 11.6391 52 26ZM19.1242 14.9398C18.3523 15.3664 17.875 16.1891 17.875 17.0625V34.9375C17.875 35.8211 18.3523 36.6336 19.1242 37.0602C19.8961 37.4867 20.8305 37.4766 21.5922 37.0094L36.2172 28.0719C36.9383 27.625 37.3852 26.843 37.3852 25.9898C37.3852 25.1367 36.9383 24.3547 36.2172 23.9078L21.5922 14.9703C20.8406 14.5133 19.8961 14.493 19.1242 14.9195V14.9398Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlaySolid);
export default __webpack_public_path__ + "static/media/circle-play-solid.4fb7cfaa95d8892858c5cd1f57fbc409.svg";
export { ForwardRef as ReactComponent };